export default __webpack_public_path__ + "static/media/d41.4176ba23.png";